/**
 * CSS breakpoints (browser window width) between different page layouts.
 * Must be identical to the $breakpoints in main.less
 */
export enum breakpoints {
    PHONE = 320,
    TABLET = 860,
    DESKTOP = 1060,
    MONITOR = 1260,
}
